import { createReducer, on } from '@ngrx/store';
import { IEMData } from '@dch/billing-business-logic';
import {
  getBillingTransactionsReferencesFailure,
  getBillingTransactionsReferencesRequest,
  getBillingTransactionsReferencesSuccess,
} from '../actions/billing-transactions-references.actions';
import { IBillingDocumentReferences } from 'src/app/my-bill/models/billing-transactions-references.model';

export interface BillingTransactionsReferencesState {
  byAccountNumber: {
    [accountNumber: string]: IEMData<Array<IBillingDocumentReferences>>;
  };
}

export const initialState: BillingTransactionsReferencesState = {
  byAccountNumber: {},
};

export const billingTransactionsReferencesReducer = createReducer(
  initialState,
  on(
    getBillingTransactionsReferencesRequest,
    (state, { billingAccountNumber }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: state.byAccountNumber[billingAccountNumber]?.result ?? null,
          hasError: false,
          isFetching: true,
        },
      },
    })
  ),
  on(
    getBillingTransactionsReferencesSuccess,
    (state, { billingAccountNumber, transactionsReferences }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: [
            ...transactionsReferences.openTransactions.billingDocuments,
            ...transactionsReferences.recentClosedTransactions.billingDocuments,
          ],
          hasError: false,
          isFetching: false,
        },
      },
    })
  ),
  on(
    getBillingTransactionsReferencesFailure,
    (state, { billingAccountNumber }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: null,
          hasError: true,
          isFetching: false,
        },
      },
    })
  )
);
